/*
 *
 * WalletDetailsPage actions
 *
 */

import {
  ADD_MONEY_TO_WALLET,
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  EXPORT_TO_CSV,
  FETCH_WALLET_HISTORY_DATA,
  GET_WALLET_BALANCE,
  GET_WALLET_STATUS,
  MODIFY_WALLET_STATUS,
  RESET_FILTERS,
  RESET_PAGE,
  SAVE_WALLET_HISTORY_DATA,
  UPDATE_BANK_DETAILS,
  UPDATE_FILTERS,
  UPDATE_WALLET_BALANCE,
  UPDATE_WALLET_STATUS,
} from './constants';

interface UpdateWalletsActionDataTypes {
  createdBy: string;
  name: string;
  refId: string;
  status: string;
  walletId: number;
  rechargeMode: { vba: string; ifsc: string };
}

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function fetchWalletHistoryDataAction(data: any) {
  return {
    type: FETCH_WALLET_HISTORY_DATA,
    data,
  };
}

export function getWalletStatusAction(data: { feeWallet: boolean }) {
  return {
    type: GET_WALLET_STATUS,
    data,
  };
}

export function updateWalletStatusAction(data: UpdateWalletsActionDataTypes) {
  return {
    type: UPDATE_WALLET_STATUS,
    data,
  };
}

export function getWalletBalanceAction(data: any) {
  return {
    type: GET_WALLET_BALANCE,
    data,
  };
}

export function updateWalletBalanceAction(data: { balance: string }) {
  return {
    type: UPDATE_WALLET_BALANCE,
    data,
  };
}

export function addMoneyToWalletAction(data: { feeWallet: boolean }) {
  return {
    type: ADD_MONEY_TO_WALLET,
    data,
  };
}

export function modifyWalletStatusAction(data: {
  referenceId: string;
  name: string;
  status: string;
  cb: Function;
}) {
  return {
    type: MODIFY_WALLET_STATUS,
    data,
  };
}

export function saveWalletHistoryDataAction(data: any) {
  return {
    type: SAVE_WALLET_HISTORY_DATA,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function updateFiltersAction(data: any) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction() {
  return {
    type: RESET_FILTERS,
  };
}

export function resetPageAction(data: any) {
  return {
    type: RESET_PAGE,
    data,
  };
}

export function updateBankDetailsAction(data: { vba: string; ifsc: string }) {
  return {
    type: UPDATE_BANK_DETAILS,
    data,
  };
}

export function exportToCSVAction(data: any) {
  return {
    type: EXPORT_TO_CSV,
    data,
  };
}
